var AuthenticatedModule = /** @class */ (function () {
    function AuthenticatedModule() {
    }
    return AuthenticatedModule;
}());
export { AuthenticatedModule };
